class QbExport {

  constructor() {}

  init() {
    this.refreshActionButtons();
  }

  setupEvents() {
    let _this = this;

    document.querySelectorAll('input[type=checkbox][data-scope=invoice-list]').forEach(checkbox => {
      checkbox.addEventListener('click', function (event) {
        event.stopPropagation();
        _this.refreshActionButtons();
      });
      checkbox.parentNode.querySelector('label').addEventListener('click', function (event) {
        event.stopPropagation();
        _this.refreshActionButtons();
      });
    });
  }

  refreshActionButtons() {
    let hasSelection = Array.from(document.querySelectorAll('input[type=checkbox][data-scope=invoice-list]:not(.select-all)'))
      .filter(checkbox => checkbox.checked).length;

    let qb_action = document.querySelector('.qb-action');
    if (qb_action) {
      qb_action.disabled = !hasSelection;
    }
  }

  load() {
    this.init();
    this.setupEvents();
  }
}

export default new QbExport();